// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/routes/Other/Header/Header.css */

.header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: white;
    height: 8vh;
    padding: 0.75rem 2rem;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.logo-link {
    display: inline-block;
    text-decoration: none;
}

.logo-link:hover {
    opacity: 0.9;
}

.logo {
    height: 2.6rem;
    width: auto;
    cursor: pointer;
    transition: transform 0.2s ease;
}


.header-container > .logo {
    cursor: pointer;
}

.header-right {
    display: flex;
    align-items: center;
    gap: 1rem;
    min-width: 0;
}

/* Search input styling */
.header-search {
    display: flex;
    align-items: center;
    position: relative;
    margin-right: 0.5rem;
}

.header-search.queue-search .form-control {
    background-color: #f8f9fa;
    border-color: #EF6F53;
}

.header-search.queue-search .form-control:focus {
    box-shadow: 0 0 5px rgba(239, 111, 83, 0.4);
}

.form-control {
    height: 2rem;
    border-radius: 20px;
    border: 1px solid #ccc;
    padding: 0.5rem 2rem 0.5rem 1rem;
    font-size: 0.75rem;
    width: 160px;
    transition: all 0.3s ease;
}

.form-control::placeholder {
    color: #666;
    font-size: 0.75rem;
}

.form-control:focus {
    outline: none;
    width: 180px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}

.srch-icon {
    width: 15px;
    height: 15px;
    position: absolute;
    right: 10px;
    cursor: pointer;
    transition: transform 0.3s ease;
}

.srch-icon:hover {
    transform: scale(1.25);
}

.admin-link {
    display: inline-block;
    padding: 8px 16px;
    background-color: #1976d2;
    color: white;
    text-decoration: none;
    border-radius: 4px;
    font-size: 0.9rem;
    font-weight: 500;
    transition: background-color 0.3s ease;
}

.admin-link:hover {
    background-color: #1565c0;
}

/* File upload section */
.file-upload-section {
    display: flex;
    align-items: center;
    gap: 1rem;
    position: relative;
}

.file-icon {
    width: 24px;
    height: 24px;
    cursor: pointer;
    transition: transform 0.3s ease;
}

.file-icon:hover {
    transform: scale(1.25);
}

.file-upl {
    font-size: 0.85rem;
    color: #666;
    margin-right: 0.5rem;
    margin-left: -1rem;
    cursor: pointer;
    transition: color 0.3s ease;
}

.profile-section{
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
}

.profile-section .pro-icon {
    width: 35px;
    height: 35px;
    cursor: pointer;
}

.profile-section span {
    white-space: nowrap;
    text-align: center;
    color: #364C63;
}

/* Profile icon styling */
.pro-icon {
    width: 35px;
    height: 35px;
    cursor: pointer;
    transition: transform 0.3s ease;
    border-radius: 50%;
    border: 1px solid #ccc;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
}

.pro-icon:hover {
    transform: scale(1.25);
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.5);
}

.download-section {
    display: flex;
    align-items: center;
    gap: 5px;
    cursor: pointer;
    margin: 0 15px;
}

.download-icon {
    width: 20px;
    height: 20px;
}

.download-text {
    font-size: 0.85rem;
    color: #666;
}

.download-icon {
    transition: transform 0.2s;
}

.download-icon:hover {
    transform: scale(1.1);
}

.notification-icon {
    width: 25px;
    height: 25px;
    cursor: pointer;
    transition: transform 0.2s;
    border: 1px solid #b40000;
    border-radius: 45%;
    box-shadow: 0 0 3px rgba(180, 0, 0, 0.5);
}

.notification-icon:hover {
    transform: scale(1.25);
    box-shadow: 0 0 6px rgba(180, 0, 0, 0.8);
}

.profile-dropdown {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 2px;
}

.header-user-meta {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 1px;
    max-width: 210px;
    line-height: 1.1;
    text-align: right;
}

.header-user-meta .header-username {
    color: #364C63;
    font-size: 0.78rem;
    font-weight: 800;
}

.header-user-meta .header-datetime {
    color: #66788f;
    font-size: 0.62rem;
    font-weight: 600;
    white-space: normal;
}

.profile-dropdown::after {
    content: '';
    position: absolute;
    width: 10px;
    height: 10px;
    background: #fff;
    transform: translateY(-50%) rotate(45deg);
    opacity: 0;
    transition: opacity 0.3s;
    pointer-events: none;
}

.profile-dropdown:hover::after {
    opacity: 1;
}

.dropdown-content {
    display: none;
    position: absolute;
    top:100%;
    right: 0;
    background-color: white;
    min-width: 250px;
    box-shadow: 0 10px 25px rgba(0,0,0,0.1);
    border-radius: 8px;
    z-index: 1000;
    opacity: 0;
    transform: translateY(-10px);
    transition: all 0.3s ease;
    border: 1px solid rgba(0,0,0,0.08);
    backdrop-filter: blur(10px);
}

.profile-dropdown:hover .dropdown-content {
    display: block;
    opacity: 1;
    transform: translateY(0);
}

.dropdown-content a {
    color: #333;
    padding: 10px 12px;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 0.95rem;
    transition: all 0.2s ease;
    position: relative;
}

.dropdown-content a:hover {
    background-color: #f8f9fa;
    color: #EF6F53;
    padding-left: 18px;
}

.dropdown-menu-link span {
    min-width: 0;
    overflow-wrap: anywhere;
}

.dropdown-menu-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 18px;
    width: 18px;
    color: #24516f;
    font-size: 0.86rem;
    text-align: center;
    transition: color 0.2s ease, transform 0.2s ease;
}

.dropdown-content a:hover .dropdown-menu-icon,
.dropdown-footer:hover .dropdown-menu-icon {
    color: #EF6F53;
    transform: translateX(1px);
}

.dropdown-content a::before {
    content: '';
    position: absolute;
    left: 0;
    width: 4px;
    height: 0;
    background-color: #EF6F53;
    transition: height 0.2s ease;
}

.dropdown-content a:hover::before {
    height: 100%;
}

.dropdown-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    background-color: #f8f9fa;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    cursor: pointer;
}

.username-logout{
    color: #EF6F53;
    font-size: 0.8rem;
    cursor: pointer;
}
.dropdown-footer .logout-btn {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    color: #EF6F53;
    cursor: pointer;
    font-size: 0.9rem;
    font-weight: 500;
    transition: color 0.2s;
    padding: 0;
}

.dropdown-footer .logout-btn:hover {
    color: #e73710;
    font-weight: 600;
}

.dropdown-footer .username {
    color: #666;
    font-size: 0.9rem;
    font-weight: 500;  
}

@media (max-width: 820px) {
    .header-container {
        height: auto;
        padding: 0.85rem;
        gap: 0.75rem;
    }

    .header-right {
        gap: 0.5rem;
        flex-wrap: wrap;
        justify-content: flex-end;
    }

    .form-control,
    .form-control:focus {
        width: 140px;
    }

    .download-section {
        margin: 0 4px;
    }

}

@media (max-width: 560px) {
    .logo {
        height: 2.5rem;
    }

    .header-search {
        order: 3;
        width: 100%;
        margin-right: 0;
    }

    .form-control,
    .form-control:focus {
        width: 100%;
    }

    .header-user-meta {
        max-width: 150px;
    }

    .header-user-meta .header-datetime {
        display: none;
    }

}
`, "",{"version":3,"sources":["webpack://./src/components/routes/Other/Header/Header.css"],"names":[],"mappings":"AAAA,kDAAkD;;AAElD;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,qBAAqB;IACrB,wCAAwC;AAC5C;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,eAAe;IACf,+BAA+B;AACnC;;;AAGA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;AAChB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,gCAAgC;IAChC,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,sCAAsC;AAC1C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;;AAEA,yBAAyB;AACzB;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,+BAA+B;IAC/B,kBAAkB;IAClB,sBAAsB;IACtB,sCAAsC;AAC1C;;AAEA;IACI,sBAAsB;IACtB,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,0BAA0B;IAC1B,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,sBAAsB;IACtB,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,QAAQ;IACR,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,yCAAyC;IACzC,UAAU;IACV,wBAAwB;IACxB,oBAAoB;AACxB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,uBAAuB;IACvB,gBAAgB;IAChB,uCAAuC;IACvC,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,4BAA4B;IAC5B,yBAAyB;IACzB,kCAAkC;IAClC,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,gDAAgD;AACpD;;AAEA;;IAEI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,SAAS;IACT,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,yBAAyB;IACzB,8BAA8B;IAC9B,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;IACT,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI;QACI,YAAY;QACZ,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,yBAAyB;IAC7B;;IAEA;;QAEI,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;AAEJ;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,QAAQ;QACR,WAAW;QACX,eAAe;IACnB;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;AAEJ","sourcesContent":["/* src/components/routes/Other/Header/Header.css */\n\n.header-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background-color: white;\n    height: 8vh;\n    padding: 0.75rem 2rem;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n}\n\n.logo-link {\n    display: inline-block;\n    text-decoration: none;\n}\n\n.logo-link:hover {\n    opacity: 0.9;\n}\n\n.logo {\n    height: 2.6rem;\n    width: auto;\n    cursor: pointer;\n    transition: transform 0.2s ease;\n}\n\n\n.header-container > .logo {\n    cursor: pointer;\n}\n\n.header-right {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    min-width: 0;\n}\n\n/* Search input styling */\n.header-search {\n    display: flex;\n    align-items: center;\n    position: relative;\n    margin-right: 0.5rem;\n}\n\n.header-search.queue-search .form-control {\n    background-color: #f8f9fa;\n    border-color: #EF6F53;\n}\n\n.header-search.queue-search .form-control:focus {\n    box-shadow: 0 0 5px rgba(239, 111, 83, 0.4);\n}\n\n.form-control {\n    height: 2rem;\n    border-radius: 20px;\n    border: 1px solid #ccc;\n    padding: 0.5rem 2rem 0.5rem 1rem;\n    font-size: 0.75rem;\n    width: 160px;\n    transition: all 0.3s ease;\n}\n\n.form-control::placeholder {\n    color: #666;\n    font-size: 0.75rem;\n}\n\n.form-control:focus {\n    outline: none;\n    width: 180px;\n    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);\n}\n\n.srch-icon {\n    width: 15px;\n    height: 15px;\n    position: absolute;\n    right: 10px;\n    cursor: pointer;\n    transition: transform 0.3s ease;\n}\n\n.srch-icon:hover {\n    transform: scale(1.25);\n}\n\n.admin-link {\n    display: inline-block;\n    padding: 8px 16px;\n    background-color: #1976d2;\n    color: white;\n    text-decoration: none;\n    border-radius: 4px;\n    font-size: 0.9rem;\n    font-weight: 500;\n    transition: background-color 0.3s ease;\n}\n\n.admin-link:hover {\n    background-color: #1565c0;\n}\n\n/* File upload section */\n.file-upload-section {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    position: relative;\n}\n\n.file-icon {\n    width: 24px;\n    height: 24px;\n    cursor: pointer;\n    transition: transform 0.3s ease;\n}\n\n.file-icon:hover {\n    transform: scale(1.25);\n}\n\n.file-upl {\n    font-size: 0.85rem;\n    color: #666;\n    margin-right: 0.5rem;\n    margin-left: -1rem;\n    cursor: pointer;\n    transition: color 0.3s ease;\n}\n\n.profile-section{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    position: relative;\n}\n\n.profile-section .pro-icon {\n    width: 35px;\n    height: 35px;\n    cursor: pointer;\n}\n\n.profile-section span {\n    white-space: nowrap;\n    text-align: center;\n    color: #364C63;\n}\n\n/* Profile icon styling */\n.pro-icon {\n    width: 35px;\n    height: 35px;\n    cursor: pointer;\n    transition: transform 0.3s ease;\n    border-radius: 50%;\n    border: 1px solid #ccc;\n    box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\n}\n\n.pro-icon:hover {\n    transform: scale(1.25);\n    box-shadow: 0 0 8px rgba(0, 0, 0, 0.5);\n}\n\n.download-section {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    cursor: pointer;\n    margin: 0 15px;\n}\n\n.download-icon {\n    width: 20px;\n    height: 20px;\n}\n\n.download-text {\n    font-size: 0.85rem;\n    color: #666;\n}\n\n.download-icon {\n    transition: transform 0.2s;\n}\n\n.download-icon:hover {\n    transform: scale(1.1);\n}\n\n.notification-icon {\n    width: 25px;\n    height: 25px;\n    cursor: pointer;\n    transition: transform 0.2s;\n    border: 1px solid #b40000;\n    border-radius: 45%;\n    box-shadow: 0 0 3px rgba(180, 0, 0, 0.5);\n}\n\n.notification-icon:hover {\n    transform: scale(1.25);\n    box-shadow: 0 0 6px rgba(180, 0, 0, 0.8);\n}\n\n.profile-dropdown {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 2px;\n}\n\n.header-user-meta {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 1px;\n    max-width: 210px;\n    line-height: 1.1;\n    text-align: right;\n}\n\n.header-user-meta .header-username {\n    color: #364C63;\n    font-size: 0.78rem;\n    font-weight: 800;\n}\n\n.header-user-meta .header-datetime {\n    color: #66788f;\n    font-size: 0.62rem;\n    font-weight: 600;\n    white-space: normal;\n}\n\n.profile-dropdown::after {\n    content: '';\n    position: absolute;\n    width: 10px;\n    height: 10px;\n    background: #fff;\n    transform: translateY(-50%) rotate(45deg);\n    opacity: 0;\n    transition: opacity 0.3s;\n    pointer-events: none;\n}\n\n.profile-dropdown:hover::after {\n    opacity: 1;\n}\n\n.dropdown-content {\n    display: none;\n    position: absolute;\n    top:100%;\n    right: 0;\n    background-color: white;\n    min-width: 250px;\n    box-shadow: 0 10px 25px rgba(0,0,0,0.1);\n    border-radius: 8px;\n    z-index: 1000;\n    opacity: 0;\n    transform: translateY(-10px);\n    transition: all 0.3s ease;\n    border: 1px solid rgba(0,0,0,0.08);\n    backdrop-filter: blur(10px);\n}\n\n.profile-dropdown:hover .dropdown-content {\n    display: block;\n    opacity: 1;\n    transform: translateY(0);\n}\n\n.dropdown-content a {\n    color: #333;\n    padding: 10px 12px;\n    text-decoration: none;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    font-size: 0.95rem;\n    transition: all 0.2s ease;\n    position: relative;\n}\n\n.dropdown-content a:hover {\n    background-color: #f8f9fa;\n    color: #EF6F53;\n    padding-left: 18px;\n}\n\n.dropdown-menu-link span {\n    min-width: 0;\n    overflow-wrap: anywhere;\n}\n\n.dropdown-menu-icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex: 0 0 18px;\n    width: 18px;\n    color: #24516f;\n    font-size: 0.86rem;\n    text-align: center;\n    transition: color 0.2s ease, transform 0.2s ease;\n}\n\n.dropdown-content a:hover .dropdown-menu-icon,\n.dropdown-footer:hover .dropdown-menu-icon {\n    color: #EF6F53;\n    transform: translateX(1px);\n}\n\n.dropdown-content a::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    width: 4px;\n    height: 0;\n    background-color: #EF6F53;\n    transition: height 0.2s ease;\n}\n\n.dropdown-content a:hover::before {\n    height: 100%;\n}\n\n.dropdown-footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 12px;\n    background-color: #f8f9fa;\n    border-bottom-left-radius: 8px;\n    border-bottom-right-radius: 8px;\n    cursor: pointer;\n}\n\n.username-logout{\n    color: #EF6F53;\n    font-size: 0.8rem;\n    cursor: pointer;\n}\n.dropdown-footer .logout-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 10px;\n    color: #EF6F53;\n    cursor: pointer;\n    font-size: 0.9rem;\n    font-weight: 500;\n    transition: color 0.2s;\n    padding: 0;\n}\n\n.dropdown-footer .logout-btn:hover {\n    color: #e73710;\n    font-weight: 600;\n}\n\n.dropdown-footer .username {\n    color: #666;\n    font-size: 0.9rem;\n    font-weight: 500;  \n}\n\n@media (max-width: 820px) {\n    .header-container {\n        height: auto;\n        padding: 0.85rem;\n        gap: 0.75rem;\n    }\n\n    .header-right {\n        gap: 0.5rem;\n        flex-wrap: wrap;\n        justify-content: flex-end;\n    }\n\n    .form-control,\n    .form-control:focus {\n        width: 140px;\n    }\n\n    .download-section {\n        margin: 0 4px;\n    }\n\n}\n\n@media (max-width: 560px) {\n    .logo {\n        height: 2.5rem;\n    }\n\n    .header-search {\n        order: 3;\n        width: 100%;\n        margin-right: 0;\n    }\n\n    .form-control,\n    .form-control:focus {\n        width: 100%;\n    }\n\n    .header-user-meta {\n        max-width: 150px;\n    }\n\n    .header-user-meta .header-datetime {\n        display: none;\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
